// dashboard/frontend/src/components/Footer/Footer.js
import React from 'react';
import { 
    Box, 
    Container, 
    Link, 
    Typography, 
    Grid, 
    useTheme,
    useMediaQuery
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const footerLinks = [
        { to: "/", text: "Home" },
        { to: "/contact", text: "Contact Us" },
        { to: "/terms", text: "Terms of Service" },
        { to: "/privacy", text: "Privacy Policy" },
        { to: "/auth/login", text: "Login" }
    ];

    return (
        <Box
            component="footer"
            sx={{
                py: 3,
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[200]
                        : theme.palette.grey[800],
                width: '100%',  // Ensure full width
                mt: 'auto'  // Push footer to bottom
            }}
        >
            <Container maxWidth="lg">
                {isMobile ? (
                    // Mobile layout - grid system
                    <Grid container spacing={1} justifyContent="center">
                        {footerLinks.map((link) => (
                            <Grid item xs={6} key={link.text}>
                                <Link
                                    component={RouterLink}
                                    to={link.to}
                                    color="text.secondary"
                                    sx={{
                                        textDecoration: 'none',
                                        display: 'block',
                                        textAlign: 'center',
                                        py: 1,
                                        px: 1,
                                        '&:hover': { 
                                            color: 'primary.main',
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                        }
                                    }}
                                >
                                    {link.text}
                                </Link>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    // Desktop layout - horizontal flex
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 4
                        }}
                    >
                        {footerLinks.map((link) => (
                            <Link
                                key={link.text}
                                component={RouterLink}
                                to={link.to}
                                color="text.secondary"
                                sx={{ 
                                    textDecoration: 'none',
                                    '&:hover': { color: 'primary.main' }
                                }}
                            >
                                {link.text}
                            </Link>
                        ))}
                    </Box>
                )}

                <Typography 
                    variant="body2" 
                    color="text.secondary" 
                    align="center"
                    sx={{ 
                        mt: 2,
                        whiteSpace: 'pre-line',
                        px: isMobile ? 2 : 0 // Add padding on mobile
                    }}
                >
                    © {new Date().getFullYear()} {window.location.hostname.includes('wpappdev.com') ? 'ArgusSTAGING' : 'ArgusCMS'}, a{' '}
                    <Link 
                        href="https://www.wpappdev.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        color="inherit"
                        sx={{ 
                            textDecoration: 'none',
                            '&:hover': { 
                                textDecoration: 'underline',
                                color: 'primary.main'
                            }
                        }}
                    >
                        wpAppDev
                    </Link>
                    {' '}product.{'\n'}Provider of AI Integrations and Web Services by{' '}
                    <Link 
                        href="https://www.imarketllc.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        color="inherit"
                        sx={{ 
                            textDecoration: 'none',
                            '&:hover': { 
                                textDecoration: 'underline',
                                color: 'primary.main'
                            }
                        }}
                    >
                        iMarket LLC
                    </Link>
                    . All rights reserved.
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;